import { Component, computed, inject, Signal, ChangeDetectionStrategy } from '@angular/core';
import { ConfigService, DEFAULT_CONFIG, FooterTemplate } from 'libs/shared/src';
import { FooterBasicComponent } from './basic/footer-basic.component';
import { FooterSlimComponent } from './slim/footer-slim.component';

@Component({
  selector: 'gs-footer',
  imports: [FooterBasicComponent, FooterSlimComponent],
  host: {
    '[class.shadow-top-md]': 'showShadow()'
  },
  template: `
    @let template = activeTemplate();
    @if (template) {
      @switch (template) {
        @case ('basic') {
          <footer-basic></footer-basic>
        }
        @case ('slim') {
          <footer-slim></footer-slim>
        }
      }
    }
  `,
  changeDetection: ChangeDetectionStrategy.OnPush,
  styles: `
    :host {
      display: block;
    }
  `
})
export class FooterComponent {
  // Services
  private readonly configService = inject(ConfigService);

  // Properties & Signals
  /** The current active footer template */
  protected readonly activeTemplate: Signal<FooterTemplate> = computed(() => {
    return this.configService.config()?.footer?.template ?? 'basic';
  });

  /**
   * Whether the footer drop shadow is enabled in the config.
   * Applied as a host class so the shadow sits on the wrapper element, which
   * is not clipped by its own `overflow: hidden` (unlike the inner footer,
   * whose upward shadow the wrapper would otherwise cut off).
   */
  protected readonly showShadow: Signal<boolean> = computed(() => {
    return this.configService.config()?.footer?.showShadow ?? DEFAULT_CONFIG.footer?.showShadow ?? false;
  });
}
